export const changeArrayItemPosition = <T>(data: T[], sourceIndex: number, targetIndex: number): T[] => {
    const item = data[sourceIndex]
    if (!item) {
        return data
    }
    const newData = [...data]
    newData.splice(sourceIndex, 1)
    newData.splice(targetIndex, 0, item)
    return newData
}
